import { render, staticRenderFns } from "./SinglePointGoalEditor.vue?vue&type=template&id=3809ccea&"
import script from "./SinglePointGoalEditor.vue?vue&type=script&lang=ts&"
export * from "./SinglePointGoalEditor.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports